export type DataItem = {
    identifier: string
    title: string
    description?: string
}
export type LanguageCodes = 'sq' | 'en' | 'fr' | 'it' | 'hu' | 'de' | 'auto'

export type LanguageItem = {
    identifier: string
    title: string
	selected?:string
}
export type AuthoringStatusList = {
    identifier: string
    title: string
}
export type ReviewStatusList = {
    identifier: string
    title: string
}

export type PublishingStatusList = {
    identifier: string
    title: string
}
export type MedicalSpecialties = {
    identifier: string
    title: string
}
export type AplicationDomain = {
    identifier: string
    title: string
}
export type studyTypes = {
    identifier: string
    title: string
}
export type predefinedGuidesItem = {
    identifier: string
    title: string
    description: string
}
export type allStatuses = {
    identifier: string
    title: string
}
export type outcomeType = {
    identifier: string
    title: string
}

export type TargetAudienceItem = {
    identifier: string
    title: string
}
export type SelectHeaderItem = {
    identifier: string
    title: string
	description:string
}
export type Links = {
    href: string
}

export type CVResponseData = {
    author?: DataItem[]
    language?: LanguageItem[]
    outcomeType?: outcomeType[]
    targetAudience?: TargetAudienceItem["identifier"][]
    inputMaterialType?: DataItem[]
	selectHeader?:SelectHeaderItem[]
	medicalSpeciality?:MedicalSpecialties[]
	authoringStatus?:AuthoringStatusList[]
    reviewStatus?: ReviewStatusList[]
	publishingStatus?:PublishingStatusList[]
	studyType?:studyTypes[]
	predefinedGuides?:predefinedGuidesItem[]
}

export type CVResponse = {
    data: CVResponseData
    _links?: Record<keyof CVResponseData, { href: string }>
}

export const CVDataProvided = Symbol() as InjectionKey<Ref<CVResponse>>


export type ListFilters = {
	search: string | null
    author?: DataItem["identifier"][]
    language?: LanguageItem["identifier"]
    outcomeType?: DataItem["identifier"][]
    targetAudience?: TargetAudienceItem["identifier"][]
    inputMaterialType?: DataItem["identifier"][]
    medicalSpecialties?: DataItem["identifier"][]
    studyType?: DataItem["identifier"][]
    aplicationDomain?: DataItem["identifier"][]
    allStatuses?: string | null
}